import React from "react";
import Button from "./GlobalComponents/Button";
import { useContext } from "react";
import { PanelsContext } from "../Context/PanelsContext";

const Nav = ({ isActive }) => {
  const { activeLink, setActiveLink } = useContext(PanelsContext);

  return (
    <nav style={{ width: "100%", display: "flex" }}>
      <Button
        isActive={activeLink === "first"}
        onClick={() => setActiveLink("first")}
        btnIcon="fas fa-text-height fa-sm"
        btnText="General"
      />
      <Button
        isActive={activeLink === "second"}
        onClick={() => setActiveLink("second")}
        btnIcon="fas fa-paint-brush fa-sm"
        btnText="Colors"
      />
      <Button
        isActive={activeLink === "third"}
        onClick={() => setActiveLink("third")}
        btnIcon="fas fa-ruler-combined fa-sm"
        btnText="Positioning"
      />
    </nav>
  );
};
export default Nav;
